import { useEffect, useRef } from 'react';
import { useLocation, useNavigationType } from 'react-router-dom';

import {
  PageSlideDirection,
  resolvePageSlideDirection,
} from './resolve-page-slide-direction';

export const usePageSlideDirection = (): PageSlideDirection => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const previousPathRef = useRef(location.pathname);

  const direction = resolvePageSlideDirection(
    navigationType,
    previousPathRef.current,
    location.pathname,
  );

  useEffect(() => {
    previousPathRef.current = location.pathname;
  }, [location.pathname]);

  return direction;
};
